export const applyOptimisticSave = async ({
  selectedItem,
  input,
  setLoading,
  setItems,
  setSelectedItem,
  updateItem,
  successMessage,
  errorMessage,
  onSuccess,
  onError,
}) => {
  if (!selectedItem?.id) return false;

  const optimistic = {
    ...selectedItem,
    ...input,
    id: selectedItem.id,
  };

  setLoading(true);
  setItems((prev) => prev.map((item) => (item.id === selectedItem.id ? optimistic : item)));
  setSelectedItem(optimistic);

  try {
    const updated = await updateItem(selectedItem.id, input);
    if (!updated) {
      throw new Error(`Save returned no updated ${successMessage.toLowerCase()}`);
    }

    const normalizedUpdated = {
      ...selectedItem,
      ...updated,
      id: updated?.id || selectedItem.id,
    };

    setItems((prev) => prev.map((item) => (item.id === selectedItem.id ? normalizedUpdated : item)));
    setSelectedItem(normalizedUpdated);

    if (onSuccess) onSuccess(successMessage);
    return true;
  } catch (err) {
    setItems((prev) => prev.map((item) => (item.id === selectedItem.id ? selectedItem : item)));
    setSelectedItem(selectedItem);

    if (onError) onError(err, errorMessage);
    return false;
  } finally {
    setLoading(false);
  }
};
